import { Box, Popover } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Calendar, DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian_en from "react-date-object/locales/gregorian_en";
import gregorian from "react-date-object/calendars/gregorian";
import { DataObject } from '@mui/icons-material';


export default function DatePicker({
    show,
    setShow,
    date,
    setDate,
    detail,
    notRange,
    ...props
  }) {
    const [Persian, setPersian] = useState(true);

  const handleClose = () => {
    // setAnchorEl(null);
    setShow(null);
  };
  
 
  const open = Boolean(show);
  const id = open ? "simple-popover" : undefined;
  return (
    <>
     <Popover
      id={id}
      open={open}
      anchorEl={show}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: detail ? "left" : "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: detail ? "left" : "right",
      }}
      {...props}
    >
      <Box width="505px">
        <Calendar
          value={date ? date : ""}
          onChange={setDate}
          calendar={Persian ? persian : gregorian}
          locale={Persian ? persian_fa : gregorian_en}
          range={notRange?false:true}
          rangeHover
          minDate={!notRange && new Date()}
          numberOfMonths={2}
          // weekDays={
          //   persian
          //     ? ["ش", "ی", "د", "س", "چ", "پ", "ج"]
          //     : ["S", "M", "T", "W", "T", "F", "S"]
          // }
          plugins={[
            <Box p="5px" position="bottom">
              <Box
                style={{
                  fontSize: "18px",
                  backgroundColor: "var(--koochita-blue)",
                  color: "black",
                  width: "90px",
                  textAlign: "center",
                  borderRadius: "15px",
                  border: "2px solid white",
                  boxShadow: "0px 1px 6px 1px var(--koochita-shadow)",
                  cursor: "pointer",
                }}
                onClick={handleClose}
              >
                تایید
              </Box>
            </Box>,
            <Box
              display="flex"
              p="10px"
              justifyContent="space-between"
              position="top"
            >
              <Box
                sx={{ cursor: "pointer", color: "var(--koochita-blue)" }}
                onClick={() => setPersian(!Persian)}
              >
                {"تقویم میلادی"}
              </Box>
              <Box
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  setDate(new Date());
                  setTimeout(() => {
                    setDate([]);
                  }, 1);
                }}
              >
                {"رفتن به امروز"}
              </Box>
            </Box>,
          ]}
        />
        {/* <DemoItem label="Controlled calendar">
          <DateRangeCalendar
            value={value}
            onChange={(newValue) => setValue(newValue)}
          />
          </DemoItem> */}
      </Box>
    </Popover>
    </>
  )
}
